import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
}));
export default styles;
